import React, { useState, useEffect } from 'react'
// import { useLocation } from 'react-router-dom'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ReviewGroupDataTable from '../../../widgets/dataTable/ReviewGroupDataTable'
import { getReviewHistorySchemaMulti } from '../../../redux/actions/multiReview'
import DashboradToggle from '../../../widgets/dashboard/DashboradToggle'

export default function MultiReviewGroup(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const { isNoSidebar, isSetting, isShow, onSettingChange, dashboradName } = props

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getReviewHistorySchemaMulti()

      setSchema(response)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error && !isNoSidebar) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if ((!schema || isLoading) && !isNoSidebar) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return !isNoSidebar ? (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      {schema?.forms?.mutiReviewGroupList && (
        <>
          <ReviewGroupDataTable />
          <br />
        </>
      )}
    </SidebarProposal>
  ) : (
    <>
      {schema?.forms?.mutiReviewGroupList && (
        <>
          {isSetting && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={dashboradName}
              checked={isShow}
            />
          )}
          <ReviewGroupDataTable />
        </>
      )}
    </>
  )
}
